module.exports = __webpack_public_path__ + "static/media/loyalty.d49e2136.svg";